import { Routes } from '@angular/router';
import { protectedGuards } from '../../core/auth/auth.guard';

export const gadgetsShellRoutes: Routes = [
  {
    path: 'gadgets',
    loadComponent: () =>
      import('./pages/gadget-overview/gadget-overview').then((module) => module.GadgetOverview),
    data: { titleKey: 'routes.gadgets' },
  },
];

export const gadgetsRoutes: Routes = [
  {
    path: 'gadget/:id',
    canActivate: protectedGuards,
    loadComponent: () =>
      import('./pages/gadget-detail/gadget-detail').then((module) => module.GadgetDetail),
    data: { titleKey: 'routes.gadgetDetail' },
  },
  {
    path: 'gadget-reservations',
    canActivate: protectedGuards,
    loadComponent: () =>
      import('./pages/gadget-reservations/gadget-reservations').then(
        (module) => module.GadgetReservations,
      ),
    data: { titleKey: 'routes.gadgetReservations' },
  },
  {
    path: 'gadget-help',
    canActivate: protectedGuards,
    loadComponent: () =>
      import('./pages/gadget-help/gadget-help').then((module) => module.GadgetHelp),
    data: { titleKey: 'routes.gadgetHelp' },
  },
];
